import { useI18n } from '../../context/I18nContext';
import { useLogin } from '../../context/LoginContext';
import useNetworkStatus from '../../hooks/useNetworkStatus';
import './NetworkStatusBanner.css';

const NetworkStatusBanner = () => {
  const { t } = useI18n();
  // Gate the banner on authentication so a sync error during logout teardown or
  // an expired-token wake can never surface "Connection lost" on the login
  // page (NED-4045). The hook force-hides and detaches when not authenticated.
  const { isAuthenticated } = useLogin();
  const { status, isReconnectPending, hasClient, retrySyncImmediately } = useNetworkStatus(isAuthenticated);

  if (status === 'hidden') {
    return null;
  }

  const isOffline = status === 'offline';
  const message = isOffline
    ? t('waitingToReconnectText', {}, 'Connection lost. Waiting to reconnect...')
    : t('networkConnected', {}, 'Connected to network');

  return (
    <div
      aria-live={isOffline ? 'assertive' : 'polite'}
      className={`network-status-banner network-status-banner--${status}`}
      role={isOffline ? 'alert' : 'status'}
    >
      <div className="network-status-banner__content">
        <span className="network-status-banner__dot" aria-hidden="true" />
        <span className="network-status-banner__message">{message}</span>
      </div>
      <div
        aria-hidden={!isOffline}
        className={`network-status-banner__action-slot${isOffline ? '' : ' network-status-banner__action-slot--placeholder'}`}
      >
        {isOffline && hasClient && (
          <button
            className="network-status-banner__action"
            disabled={isReconnectPending}
            onClick={retrySyncImmediately}
            type="button"
          >
            {t('networkReconnectButton', {}, 'Reconnect now')}
          </button>
        )}
      </div>
    </div>
  );
};

export default NetworkStatusBanner;